import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';

const TransitionCancelModal = NiceModal.create(
  ({ onConfirm, title = '' }: { onConfirm: () => void; title: string }) => {
    const modal = useModal('transition-cancel-modal');

    const handleClose = () => {
      modal.hide();
      setTimeout(() => {
        modal.remove();
      }, 100);
    };

    const handleConfirm = () => {
      onConfirm();
      handleClose();
    };

    const { t } = useTranslation();

    return (
      <Dialog open={modal.visible}>
        <DialogContent className="w-[90%] max-w-[320px]">
          <DialogHeader>
            <DialogTitle className="text-center text-base pt-4 pb-6 font-medium">{title}</DialogTitle>
          </DialogHeader>
          <DialogFooter className="flex justify-between gap-2">
            <Button className="flex-1" variant="outline" onClick={handleClose}>
              {t('dialog_cancel')}
            </Button>
            <Button className="flex-1" onClick={handleConfirm}>
              {t('dialog_confirm')}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    );
  }
);

export default TransitionCancelModal;
